export const SidebarRoutes = [
  {
    path: "./dashboard",
    label: "menu_sidebar_dashboard",
    icon: "dashboard"
  },
  {
    path: "./service-provider",
    label: "menu_sidebar_service_provider",
    icon: "service-provider",
    featureKey: "serviceProvider",
    permissionGroupKey: "serviceProviderPermission"
  },
  {
    path: "./takaful-provider",
    label: "menu_sidebar_takaful_provider",
    icon: "takaful-provider",
    featureKey: "takafulProvider",
    permissionGroupKey: "takafulProviderPermission"
  },
  {
    label: "menu_sidebar_management",
    icon: "management",
    featureKey: "management",
    permissionGroupKey: "management",
    children: [
      {
        label: "menu_sidebar_lead_view",
        children: [
          {
            path: "./management/leads/auto",
            label: "menu_sidebar_leads_auto",
            featureKey: "quotation",
            permissionGroupKey: "autoB2B2CLead",
            dotIcon: true
          },
          {
            path: "./management/leads/health",
            label: "menu_sidebar_leads_health",
            featureKey: "lead",
            permissionGroupKey: "leadPermission",
            dotIcon: true
          },
          {
            path: "./management/leads/travel",
            label: "menu_sidebar_leads_travel",
            featureKey: "quotationTravel",
            permissionGroupKey: "leadPermission",
            dotIcon: true
          },
          {
            path: "./management/leads/life",
            label: "menu_sidebar_leads_life",
            featureKey: "quotationLife",
            permissionGroupKey: "leadPermission",
            dotIcon: true
          }
        ]
      },
      {
        label: "menu_sidebar_management_list_management",
        children: [
          {
            path: "./management/plan-type",
            label: "menu_sidebar_management_list_management_plan_type",
            featureKey: "planType",
            permissionGroupKey: "planType",
            dotIcon: true
          },
          {
            path: "./management/coverages",
            label: "menu_sidebar_management_list_management_coverages",
            featureKey: "coverage",
            permissionGroupKey: "coverage",
            dotIcon: true
          },
          {
            path: "./management/services",
            label: "menu_sidebar_management_services",
            featureKey: "service",
            permissionGroupKey: "service",
            dotIcon: true
          },
          {
            path: "./management/exclusions",
            label: "menu_sidebar_management_exclusion",
            featureKey: "exclusion",
            permissionGroupKey: "exclusion",
            dotIcon: true
          },
          {
            path: "./management/make",
            label: "menu_sidebar_management_list_management_make",
            featureKey: "make",
            permissionGroupKey: "make",
            dotIcon: true
          },
          {
            path: "./management/model",
            label: "menu_sidebar_management_list_management_model",
            featureKey: "model",
            permissionGroupKey: "model",
            dotIcon: true
          },
          {
            path: "./management/variant",
            label: "menu_sidebar_management_list_management_variant",
            featureKey: "variant",
            permissionGroupKey: "variant",
            dotIcon: true
          },
          {
            path: "./management/region",
            label: "menu_sidebar_management_region",
            featureKey: "location",
            permissionGroupKey: "location",
            dotIcon: true
          },
          {
            path: "./management/assembly",
            label: "menu_sidebar_management_list_management_assembly",
            featureKey: "assembly",
            permissionGroupKey: "assembly",
            dotIcon: true
          }
        ]
      },
      {
        label: "menu_sidebar_management_tax_and_admin",
        children: [
          {
            path: "./management/taxation",
            label: "menu_sidebar_management_tax_and_admin_taxation",
            featureKey: "taxConfiguration",
            permissionGroupKey: "taxation",
            dotIcon: true
          },
          {
            path: "./management/payment-method",
            label: "menu_sidebar_management_tax_and_admin_payment_method",
            featureKey: "payment",
            permissionGroupKey: "paymentPermission",
            dotIcon: true
          },
          {
            path: "./management/payment-gateway",
            label: "menu_sidebar_management_tax_and_admin_payment_gateway",
            featureKey: "payment",
            permissionGroupKey: "paymentPermission",
            dotIcon: true
          },
          {
            path: "./management/transaction-cost",
            label: "menu_sidebar_management_tax_and_admin_transaction_cost",
            featureKey: "payment",
            permissionGroupKey: "paymentPermission",
            dotIcon: true
          },
          {
            path: "./management/admin",
            label: "menu_sidebar_management_tax_and_admin_admin",
            featureKey: "adminExpense",
            permissionGroupKey: "adminExpense",
            dotIcon: true
          }
        ]
      },
      {
        path: "./management/features",
        label: "menu_sidebar_management_features",
        featureKey: "featureFlag",
        permissionGroupKey: "featureFlag",
        icon: ""
      },
      {
        path: "./management/salepoint",
        label: "menu_sidebar_management_sale_point",
        featureKey: "salePoint",
        permissionGroupKey: "salePoint"
      },
      {
        path: "./management/blogs",
        label: "menu_sidebar_management_blogs",
        featureKey: "salePoint",
        permissionGroupKey: "salePoint"
      },
      {
        path: "./management/faq",
        label: "menu_sidebar_manage_faq",
        featureKey: "faq",
        permissionGroupKey: "faqs"
      },
      {
        path: "./management/coupons",
        label: "menu_sidebar_coupon",
        featureKey: "coupon",
        permissionGroupKey: "coupon"
      }
    ]
  },
  {
    label: "menu_sidebar_health",
    icon: "health",
    featureKey: "healthShelfPlan",
    permissionGroupKey: "shelfPlan",
    children: [
      {
        label: "menu_sidebar_health_orders",
        path: "./health/orders"
      },
      {
        label: "menu_sidebar_health_plan_setup",
        children: [
          {
            label: "menu_sidebar_health_plan_setup_b2c",
            dotIcon: true,
            children: [
              {
                path: "./health/plan-setup/b2c/shelf-plans",
                label: "menu_sidebar_health_plan_setup_b2c_shelf_plans",
                featureKey: "healthShelfPlan",
                permissionGroupKey: "shelfPlan"
              },
              {
                label: "menu_sidebar_health_plan_setup_b2c_customized_plans",
                featureKey: "customizePlan",
                permissionGroupKey: "customizePlan"
              }
            ]
          },
          {
            label: "menu_sidebar_health_plan_setup_b2b",
            dotIcon: true,
            children: [
              {
                path: "./health/plan-setup/b2b/plans",
                label: "menu_sidebar_health_plan_setup_plans",
                featureKey: "businessAndCommunities",
                permissionGroupKey: "bacPlan"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    label: "menu_sidebar_travel",
    icon: "travel",
    featureKey: "healthShelfPlan",
    permissionGroupKey: "shelfPlan",
    children: [
      {
        label: "menu_sidebar_health_orders",
        path: "./travel/orders"
      },
      {
        label: "menu_sidebar_health_plan_setup",
        children: [
          {
            label: "menu_sidebar_health_plan_setup_b2c",
            dotIcon: true,
            children: [
              {
                path: "./travel/plan-setup/b2c/shelf-plans",
                label: "menu_sidebar_health_plan_setup_b2c_shelf_plans",
                featureKey: "healthShelfPlan",
                permissionGroupKey: "shelfPlan"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    label: "menu_sidebar_personal_accident",
    icon: "health",
    featureKey: "healthShelfPlan",
    permissionGroupKey: "shelfPlan",
    children: [
      {
        label: "menu_sidebar_health_orders",
        path: "./personal-accident/orders"
      },
      {
        label: "menu_sidebar_health_plan_setup",
        children: [
          {
            label: "menu_sidebar_health_plan_setup_b2c",
            dotIcon: true,
            children: [
              {
                path: "./personal-accident/plan-setup/b2c/shelf-plans",
                label: "menu_sidebar_health_plan_setup_b2c_shelf_plans",
                featureKey: "healthShelfPlan",
                permissionGroupKey: "shelfPlan"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    label: "menu_sidebar_house_hold",
    icon: "health",
    featureKey: "healthShelfPlan",
    permissionGroupKey: "shelfPlan",
    children: [
      {
        label: "menu_sidebar_health_orders",
        path: "./house-hold/orders"
      },
      {
        label: "menu_sidebar_health_plan_setup",
        children: [
          {
            label: "menu_sidebar_health_plan_setup_b2c",
            dotIcon: true,
            children: [
              {
                path: "./house-hold/plan-setup/b2c/shelf-plans",
                label: "menu_sidebar_health_plan_setup_b2c_shelf_plans",
                featureKey: "healthShelfPlan",
                permissionGroupKey: "shelfPlan"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    label: "menu_sidebar_life",
    icon: "health",
    featureKey: "healthShelfPlan",
    permissionGroupKey: "shelfPlan",
    children: [
      {
        label: "menu_sidebar_health_orders",
        path: "./life/orders"
      },
      {
        label: "menu_sidebar_health_plan_setup",
        children: [
          {
            label: "menu_sidebar_health_plan_setup_b2c",
            dotIcon: true,
            children: [
              {
                path: "./life/plan-setup/b2c/shelf-plans",
                label: "menu_sidebar_health_plan_setup_b2c_shelf_plans"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    label: "menu_sidebar_auto",
    icon: "auto",
    featureKey: "autoPlan",
    permissionGroupKey: "autoB2B2CPlan",
    children: [
      {
        label: "menu_sidebar_auto_orders",
        path: "./auto/orders",
        featureKey: "autoPlan",
        permissionGroupKey: "autoB2B2CPlan"
      },
      {
        label: "menu_sidebar_auto_plan_setup",
        children: [
          {
            label: "menu_sidebar_auto_plan_setup_b2c",
            dotIcon: true,
            children: [
              {
                path: "./auto/plan-setup/b2c/shelf-plans",
                label: "menu_sidebar_auto_plan_setup_b2c_shelf_plans",
                featureKey: "autoPlan",
                permissionGroupKey: "autoB2B2CPlan"
              }
            ]
          },
          {
            label: "menu_sidebar_auto_plan_setup_b2b2c",
            dotIcon: true,
            children: [
              {
                path: "./auto/plan-setup/b2b2c/shelf-plans",
                label: "menu_sidebar_auto_plan_setup_b2b2c_shelf_plans",
                featureKey: "autoPlan",
                permissionGroupKey: "autoB2B2CPlan"
              }
            ]
          },
          {
            label: "menu_sidebar_auto_plan_setup_b2b",
            dotIcon: true,
            children: [
              {
                path: "./auto/plan-setup/b2b/plans",
                label: "menu_sidebar_auto_plan_setup_plans",
                featureKey: "businessAndCommunities",
                permissionGroupKey: "bacPlan"
              }
            ]
          }
        ]
      }
    ]
  },

  {
    label: "menu_sidebar_family",
    icon: "health",
    featureKey: "autoPlan",
    permissionGroupKey: "autoB2B2CPlan",
    children: [
      {
        label: "menu_sidebar_family_plan_setup",
        children: [
          {
            label: "menu_sidebar_family_plan_setup_b2b",
            dotIcon: true,
            children: [
              {
                path: "./family/plan-setup/b2b/plans",
                label: "menu_sidebar_family_plan_setup_plans",
                featureKey: "businessAndCommunities",
                permissionGroupKey: "bacPlan"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    label: "menu_sidebar_management_user",
    icon: "user-management",
    featureKey: "user",
    permissionGroupKey: "takafulBazaarUser",
    children: [
      {
        path: "./management/user/roles",
        label: "menu_sidebar_management_user_roles",
        icon: "",
        featureKey: "user",
        permissionGroupKey: "rolesAndPermission"
      },
      {
        path: "./management/user/user-list",
        label: "menu_sidebar_management_user_team_management",
        icon: "",
        featureKey: "user",
        permissionGroupKey: "takafulBazaarUser"
      },
      {
        path: "./management/user/partner-user",
        label: "menu_sidebar_management_user_partner_user",
        icon: "",
        featureKey: "partner",
        permissionGroupKey: "partnerUser"
      },
      {
        path: "./management/user/partner-b2b-user",
        label: "menu_sidebar_management_user_partner_b2b_user",
        icon: "",
        featureKey: "businessAndCommunities",
        permissionGroupKey: "bacUser"
      }
    ]
  },
  {
    label: "menu_sidebar_reports",
    icon: "report",
    featureKey: "report",
    permissionGroupKey: "finance",
    children: [
      {
        path: "./reports/finance",
        label: "menu_sidebar_reports_finance",
        icon: "",
        featureKey: "report",
        permissionGroupKey: "finance"
      }
    ]
  },
  {
    label: "menu_sidebar_partner",
    icon: "partner",
    featureKey: "partner",
    permissionGroupKey: "partner",
    children: [
      {
        path: "./partner/b2b",
        label: "menu_sidebar_partner_b2b",
        icon: "",
        featureKey: "businessAndCommunities",
        permissionGroupKey: "bacPlan"
      },
      {
        label: "menu_sidebar_partner_b2b2c",
        icon: "",
        featureKey: "partner",
        permissionGroupKey: "partner",
        children: [
          {
            path: "./partner",
            label: "menu_sidebar_partner_b2b2c_listing",
            icon: "",
            featureKey: "partner",
            permissionGroupKey: "partner",
            dotIcon: true
          },
          {
            path: "./partner/incentive-management",
            label: "menu_sidebar_partner_incentive_management",
            icon: "",
            featureKey: "partner",
            permissionGroupKey: "partner",
            dotIcon: true
          },
          {
            path: "./partner/encashment-request",
            label: "menu_sidebar_partner_encashment_request",
            icon: "",
            dotIcon: true,
            featureKey: "partner",
            permissionGroupKey: "partner"
          }
        ]
      }
    ]
  }
];
